<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="header">Have you had any falls?</h1>
                <h2 class="subheader"></h2>
            </div>
        </div>
        <div v-if="generalErrorMessage" class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ generalErrorMessage }}
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <form @submit.prevent="submit()">
                    <div class="form-row">
                        <div class="col-md-6">
                            <b-form-group label="Falls" :state="stateForField('hasFallen')" :invalid-feedback="errorForField('hasFallen')">
                                <b-form-select size="lg" @input="clearFieldError('hasFallen')" v-model="senior.hasFallen" :state="stateForField('hasFallen')" :options="yesNoOptions"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group v-if="showFallDetails" label="How many falls?" :state="stateForField('fallCountId')" :invalid-feedback="errorForField('fallCountId')">
                                <b-form-select size="lg" @input="clearFieldError('fallCountId')" v-model="senior.fallCountId" :state="stateForField('fallCountId')" :options="fallCountOptions"></b-form-select>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <b-form-group v-if="showFallDetails" label="Did the fall cause your injury?" :state="stateForField('causedInjury')" :invalid-feedback="errorForField('causedInjury')">
                                <b-form-select size="lg" @input="clearFieldError('causedInjury')" v-model="senior.causedInjury" :state="stateForField('causedInjury')" :options="yesNoOptions"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                        </div>
                    </div>
                    <div class="form-row">
                        <button type="submit" @click.prevent="submit()" class="btn btn-primary btn-lg mx-auto mt-2" style="width: 40%"><font-awesome-icon class="mr-2" v-show="isSaving" icon="spinner" pulse/>Next</button>
                    </div>
                </form>
            </div>
            <div class="col-xl-3"></div>
        </div>
    </div>
</template>

<script>
  import api from '../../services/api'
  import ErrorsMixin from '../../mixins/ErrorsMixin'
  import OptionsMixin from '../../mixins/OptionsMixin'
  import { BFormSelect, BFormGroup } from 'bootstrap-vue'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'Falls',

    components: { BFormGroup, BFormSelect },

    mixins: [ErrorsMixin, OptionsMixin, AnalyticsMixin],

    data () {
      return {
        senior: {
          hasFallen: false,
          causedInjury: false,
          fallCountId: 0,
          fallCountOptions: []
        },
        isSaving: false,
        yesNoOptions: [
          {
            value: null,
            text: ''
          },
          {
            text: 'Yes',
            value: true
          },
          {
            text: 'No',
            value: false
          }
        ]
      }
    },

    computed: {
      promptPneumonia () {
        return this.$store.boolForModuleConfig('Senior', 'PromptPneumonia', true)
      },

      promptAdvancedDirective () {
        return this.$store.boolForModuleConfig('Senior', 'PromptAdvancedDirective', true)
      },

      fallCountOptions () {
        return this.optionsFromArray(this.senior.fallCountOptions, 'fallCountId')
      },

      showFallDetails () {
        return this.senior.hasFallen
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (this.senior.hasFallen !== true && this.senior.hasFallen !== false) {
          this.addErrorForField('hasFallen', 'Please select an option.')
        }

        if (this.showFallDetails && !this.senior.fallCountId) {
          this.addErrorForField('fallCountId', 'The number of falls is required.')
        }

        if (this.showFallDetails && this.senior.causedInjury !== true && this.senior.causedInjury !== false) {
          this.addErrorForField('causedInjury', 'Please select an option.')
        }

        return !this.hasErrors()
      },

      loadData () {
        api.get('/Patient/Senior').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)
          this.senior = response.data
          if (this.senior.isSenior === false) {
            this.$store.setModuleStatus('Senior', true, () => {
              this.isSaving = false
              this.$router.push(this.$store.nextRoute())
            })
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      submit () {
        if (this.validate() !== true) {
          return
        }

        this.isSaving = true
        api.put('/Patient/Senior', this.senior).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)
          if (this.promptPneumonia) {
            this.$router.push('pneumonia-vaccine')
          } else if (this.promptAdvancedDirective) {
            this.$router.push('living-will')
          } else {
            this.$store.setModuleStatus('Senior', true, () => {
              this.isSaving = false
              this.$router.push(this.$store.nextRoute())
            })
          }
          this.isSaving = false
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.setFromApiErrorResponse(error)
          }
        })
      }

    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

</style>
